import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

const Channel = Loadable(lazy(() => import('views/Channel')));
const Log = Loadable(lazy(() => import('views/Log')));
const Conversation = Loadable(lazy(() => import('views/Conversation')));
const Task = Loadable(lazy(() => import('views/Task')));
const BillingReview = Loadable(lazy(() => import('views/BillingReview')));
const Reconciliation = Loadable(lazy(() => import('views/Reconciliation')));
const Revenue = Loadable(lazy(() => import('views/Revenue')));
const Profit = Loadable(lazy(() => import('views/Profit')));
const Models = Loadable(lazy(() => import('views/Models')));
const ModelDetail = Loadable(lazy(() => import('views/Models/ModelDetail')));
const ModelCatalog = Loadable(lazy(() => import('views/ModelCatalog')));
const Guide = Loadable(lazy(() => import('views/Guide')));
const Playground = Loadable(lazy(() => import('views/Playground')));
const Subscription = Loadable(lazy(() => import('views/Subscription')));
const Alert = Loadable(lazy(() => import('views/Alert')));
const ChannelPool = Loadable(lazy(() => import('views/ChannelPool')));
const Redemption = Loadable(lazy(() => import('views/Redemption')));
const Setting = Loadable(lazy(() => import('views/Setting')));
const Token = Loadable(lazy(() => import('views/Token')));
const Orders = Loadable(lazy(() => import('views/Orders')));
const Topup = Loadable(lazy(() => import('views/Topup')));
const Plan = Loadable(lazy(() => import('views/Plan')));
const Ledger = Loadable(lazy(() => import('views/Ledger')));
const Usage = Loadable(lazy(() => import('views/Usage')));
const PromoterAdmin = Loadable(lazy(() => import('views/Invite/PromoterAdmin')));
const Invite = Loadable(lazy(() => import('views/Invite')));
const User = Loadable(lazy(() => import('views/User')));
const Profile = Loadable(lazy(() => import('views/Profile')));
const NotFoundView = Loadable(lazy(() => import('views/Error')));

// dashboard routing
const Dashboard = Loadable(lazy(() => import('views/Dashboard')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/panel',
  element: <MainLayout />,
  children: [
    {
      // 登录落地页 = 开始使用（原来是数据分析总览，新用户看空图表会迷茫）
      path: '',
      element: <Guide />
    },
    {
      path: 'dashboard',
      element: <Dashboard />
    },
    {
      path: 'usage',
      element: <Usage />
    },
    {
      path: 'promoter',
      element: <PromoterAdmin />
    },
    {
      path: 'invite',
      element: <Invite />
    },
    {
      path: 'channel',
      element: <Channel />
    },
    {
      path: 'channel_pool',
      element: <ChannelPool />
    },
    {
      path: 'log',
      element: <Log />
    },
    {
      path: 'conversation',
      element: <Conversation />
    },
    {
      path: 'task',
      element: <Task />
    },
    {
      path: 'billing_review',
      element: <BillingReview />
    },
    {
      path: 'reconciliation',
      element: <Reconciliation />
    },
    {
      path: 'revenue',
      element: <Revenue />
    },
    {
      path: 'profit',
      element: <Profit />
    },
    {
      path: 'models',
      element: <Models />
    },
    {
      path: 'models/:model',
      element: <ModelDetail />
    },
    {
      path: 'model_catalog',
      element: <ModelCatalog />
    },
    {
      path: 'guide',
      element: <Guide />
    },
    {
      path: 'subscription',
      element: <Subscription />
    },
    {
      path: 'playground',
      element: <Playground />
    },
    {
      path: 'alert',
      element: <Alert />
    },
    {
      path: 'redemption',
      element: <Redemption />
    },
    {
      path: 'setting',
      element: <Setting />
    },
    {
      path: 'token',
      element: <Token />
    },
    {
      path: 'orders',
      element: <Orders />
    },
    {
      path: 'topup',
      element: <Topup />
    },
    {
      path: 'plan',
      element: <Plan />
    },
    {
      path: 'ledger',
      element: <Ledger />
    },
    {
      path: 'user',
      element: <User />
    },
    {
      path: 'profile',
      element: <Profile />
    },
    {
      path: '404',
      element: <NotFoundView />
    }
  ]
};

export default MainRoutes;
